import React from "react";
import Navbar from "../Navbar";
import Carousel from "../Carasol";
import About from "../About";
import Products from "../Products";
import Operations from "../Operations";
import Testimonial from "../Testimonial";
import ContactUs from "../ContactUs";
import WhatsAppButton from "../utils/WB";
import Vision from "../Vision";
import Founder from "../Founder";
import Services from "../Services";

const Home = () => {
  return (
    <>
      <Navbar />
      <Carousel />
      <About />
      <Founder />
      <Services />

      <Products />
      <Vision />
      <Operations />

      <Testimonial />
      <ContactUs />
      <WhatsAppButton />
    </>
  );
};

export default Home;
